module.exports = __webpack_public_path__ + "media/images/smart_phone/menus/201809/top_images/1-81c9d9cbe70366957a6fa7ce05777110.png";